import { gridBreakPoints } from 'common/theme'
import styled from 'styled-components'

export const StyledUserMenu = styled.div<{ show: boolean; isSticky: boolean; assetFolder: string }>`
  color: ${({ theme }) => theme.colors.fontColor};
  /* display: flex;
  flex-direction: column; */
  align-items: end;
  padding: 1.8rem 1.825rem 0;

  .username {
    font-size: 1.5rem;
    font-weight: 400;
    display: flex;
    align-items: center;
    //gap: 1rem;
    color: ${({ isSticky, assetFolder, theme }) => {
      if (isSticky) {
        return theme.headerSticky.userMenuFont
      }
      return theme.headerNotSticky.userMenuFont
    }};
    svg {
      display: inline-block;
    }
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    display: ${({ show }) => (show ? 'flex' : 'none')};
    align-items: center;
    justify-content: center;
  }
`

export const StyledDealerDropdown = styled.div`
  color: ${({ theme }) => theme.colors.fontColor};
  font-size: 1.4rem;
  font-weight: 300;
  cursor: pointer;

  .current-user {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
  }

  .current-user::after {
    display: none;
  }
  .dealership-select.dropdown-menu {
    box-shadow: 0 0.3rem 0.4rem rgba(0, 0, 0, 0.15);
    font-size: inherit;
    border: none;
    border-radius: 0.3rem;
    padding: 0;
    display: block;
    transition: all 167ms ease-in;
    transform: translate(0.0015625rem, 6.2rem);
    inset: 0 0 auto auto !important;

    &.show {
      opacity: 1;
    }

    hr {
      margin: 0;
    }

    .associated-dealerships {
      max-height: 50rem;
      overflow: auto;
    }
  }
  .dealership-item {
    color: ${({ theme }) => theme.colors.defaultTextColor};
    font-weight: 400;
    font-size: 15px;
    height: 2.5rem;
    display: flex;
    align-items: center;
    transition: all 167ms ease-in;
    position: relative;
    background-color: transparent;

    svg {
      visibility: hidden;
      margin-right: 1rem;
    }
    &:hover,
    &.active,
    &.show-icon {
      color: ${({ theme }) => theme.colors.InfinitiLinkColor};
      svg {
        visibility: visible;
      }
    }

    &.functionality {
      height: auto;
      margin: 0.625rem 0;
    }
  }
`

export const StyledCurrentDealership = styled.div<{ isSticky: boolean }>`
  text-align: right;
  font-weight: 300;
  color: ${({ isSticky, theme }) => {
    if (isSticky) {
      return theme.headerSticky.userMenuFont
    }
    return theme.headerNotSticky.userMenuFont
  }};
`

export const RightActionContainer = styled.div<{ show: boolean; isSticky: boolean }>`
  display: flex;

  .nav-link.faq-link {
    transform: translateX(20px);
    color: ${({ theme, isSticky }) => (isSticky ? theme.headerSticky.text : theme.headerNotSticky.text)} !important;
  }

  .nav-link.faq-link:hover,
  .nav-link.faq-link:active {
    color: ${({ theme, isSticky }) =>
      isSticky ? theme.headerSticky.textHover : theme.headerNotSticky.textHover} !important;
  }

  @media (max-width: ${gridBreakPoints.lg}) {
    display: ${({ show }) => (show ? 'flex' : 'none')};
    flex-direction: column;
    align-items: center;

    & > div.nav {
      width: 100%;
      display: flex;
      flex-direction: column;

      .nav-item {
        width: 100%;
        border-top: 0.1rem solid ${({ theme }) => theme.colors.secondary};
        border-bottom: 0.1rem solid ${({ theme }) => theme.colors.secondary};

        &:hover > .nav-link {
          background-color: white;
        }

        > .nav-link {
          font-size: 1.8rem;
          height: 4rem;
          margin: unset;
          text-align: center;
          &:hover {
            color: ${({ theme }) => theme.colors.fontColor};
          }
          &.active {
            background: #d4d4d4;
            :after {
              content: none;
            }
          }
        }
      }
    }
  }

  & > div.nav {
    .nav-link {
      justify-content: center;
      font-size: 1.6rem;
      font-weight: 400;
      color: ${({ theme }) => theme.colors.primary};
      padding: 0.8rem 0;
      margin-right: 1.5rem;
      margin-top: 1rem;
    }
  }
`
